/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Resolve_TiesInputs */



/**
* | output |
* | --- |
* | "Resolve ties in top 5 before starting finals." |
*
* @param {Overview_Resolve_TiesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_resolve_ties = /** @type {((inputs?: Overview_Resolve_TiesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Resolve_TiesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résolvez les égalités dans le top 5 avant de commencer la finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resuelva los empates en el top 5 antes de iniciar finales.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resolva empates no top 5 antes de iniciar as finais.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risolvi i pareggi nella top 5 prima di iniziare le finali.")
	return /** @type {LocalizedString} */ ("Resolve ties in top 5 before starting finals.")
});